<template>
    <LoadingVue v-if="isLoading"/>
    <div v-else class="screen-number full__screen">
        <div class="screen-number__box-content number">
            <div class="screen-number__box-content-header">
                <p class="screen-number__box-content__select-limit">
                    {{
                        getTranslatedText(
                             'Select [max] [ball]',
                            {
                                max: ball.max,
                                ball: getTranslatedText('balls'),
                            },
                        )
                    }}
                </p>
                <ButtonCommon
                    :isNoHover="true"
                    icon="quickpick"
                    type="error"
                    value="Quick Pick"
                    className="screen-number__box-content__box-button__btn"
                    @on-click-button-common="onClickQuickPick()"
                />
            </div>
            <div class="screen-number__box-content__list-number">
                <div
                    v-for="(number, index) in ball.list"
                    :class="[
                        'screen-number__box-content__list-number__item',
                        { active: ball.selected.includes(number) },
                    ]"
                    :key="index"
                    @click="() => onSelectNumber(number)"
                >
                    {{ number }}
                </div>
            </div>
            <div class="screen-number__box-content__value-number">
                <input
                    v-model="ball.text"
                    class="screen-number__input__number"
                    type="text"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    ref="inputValueNumber"
                    autocomplete="off"
                    @blur="onBlurValueBall"
                    @keyup="removeDotDash"
                    @keyup.enter="hideKeypad('inputValueNumber')"
                    :placeholder="getTranslatedText('Choose your number')"
                />
                <ButtonCommon
                    v-if="ball.selected.length > 0"
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                    type="outline"
                    value="clear"
                    @on-click-button-common="onClearSelectNumber(item)"
                />
            </div>
        </div>
        <div class="screen-number__box-content action">
            <div class="screen-number__box-content__action__top">
                <span class="screen-number__box-content__action__top-title">
                    {{ getTranslatedText('Selected') }}
                </span>
                <div class="screen-number__box-content__action__top-list">
                    <template v-for="(v, i) in ball.selected" :key="i">
                        <div class="screen-number__box-content__action__top-item">
                            {{ v }}
                        </div>
                    </template>
                </div>
            </div>
            <div class="screen-number__box-content__action__bottom">
                <div class="screen-number__footer-action-price">
                    <p class="screen-number__title">
                        {{ getTranslatedText('stake') }}
                    </p>

                    <input
                        ref="inputPriceTicket"
                        v-model="wager.amount"
                        min="0"
                        max="100"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        class="screen-number__input__number price"
                        disabled
                    />
                </div>
                <div class="screen-number__box-content__action">
                    <div class="screen-number__box-content__action__bottom__total">
                        <span class="screen-number__text bold">
                            {{ getTranslatedText('total') }}
                        </span>
                        <span class="screen-number__box-content__action__bottom__total__price">
                            {{ renderPrice(wager.total, 2) }}
                        </span>
                    </div>
                </div>
                <div class="screen-number__box-content__action__bottom__box-button">
                    <ButtonCommon
                        :isNoHover="true"
                        :isLoading="$store.state.isLoadingAddCart"
                        icon="cart"
                        value="add to cart"
                        @on-click-button-common="onAddToCart()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { formatPrice, isArrayEmpty, removeDotDash } from '@/utils/utils';
import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto';

import LottoService from '@/services/loto/loto.service';
import languageMixins from '@/mixins/language-mixins';
import ButtonCommon from '@/components/common/button/button.vue';
import LoadingVue from '@/components/common/loading/loading.vue';
import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, LoadingVue },
    data() {
        return {
            dataSource: {},
            isLoading: true,
            ball: {
                list: 0,
                selected: [],
                text: '',
                max: 0,
            },
            wager: {
                total: 0,
                amount: 0,
            },
        };
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        ...mapState(['ModulesInstantLotto']),
    },
    watch: {
        'ball.selected'() {
            this.renderValueBall();
        },
    },
    methods: {
        async fetchData() {
            try {
                const resp = await LottoService.getListGames(LOTTO_INSTANT.SLUG_API);
                if (!isArrayEmpty(resp.data)) {
                    console.log('🚀 ~ fetchData ~ resp.data:', resp.data);
                    const game = resp.data[0]?.game || {};
                    const setup = game?.config?.setup;

                    const ballsetArray = JSON.parse(setup['1'].ballset);
                    const ballNumber = !isArrayEmpty(ballsetArray)
                        ? ballsetArray[1]
                        : LOTTO_INSTANT.INSTANT_BALL_RENDER;

                    this.ball.list = Array.from({ length: ballNumber }, (_, i) => i + 1);
                    this.ball.max = LOTTO_INSTANT.INSTANT_BALL_PICK;

                    this.wager.amount = parseFloat(game.price);
                    this.wager.total = game.price;

                    this.dataSource = resp.data[0];
                }
            } catch (error) {
                console.log('🚀 ~ fetchData ~ error:', error);
            } finally {
                this.isLoading = false
            }
        },

        // ACTION BALL
        onSelectNumber(number) {
            const selection = this.ball.selected;
            if (this.ball.max > selection.length) {
                const index = selection.findIndex((x) => x === number);
                if (index !== -1) selection.splice(index, 1);
                else selection.push(number);
                this.ball.selected = [...selection];
            } else {
                const index = selection.findIndex((x) => x === number);
                if (index !== -1) {
                    selection.splice(index, 1);
                    this.ball.selected = [...selection];
                }
            }
        },

        onClickQuickPick() {
            let numbers = [...this.ball.list];

            numbers.sort(() => Math.random() - 0.5);
            numbers = [...numbers.slice(0, this.ball.max)];

            this.ball.selected = [...numbers];
        },

        onClearSelectNumber() {
            this.ball.selected = [];
        },

        renderTextTickets(arr) {
            let valueBallRender = '';
            arr.forEach((x, index) => {
                valueBallRender = `${valueBallRender}${index !== 0 ? ',' : ''} ${x}`;
            });
            return valueBallRender;
        },

        renderValueBall() {
            const selection = [...this.ball.selected];
            const numberSelect = selection.sort((a, b) => a - b);

            this.ball.text = this.renderTextTickets(numberSelect);
        },

        onBlurValueBall() {
            const { list, max } = this.ball;
            let inputArray = this.ball.text
                .split(',')
                .map((num) => Number(num.trim()))
                .filter((num, index, self) => num >= 1 && num <= list.length && index === self.indexOf(num));

            inputArray = inputArray.slice(0, max);
            this.ball.text = inputArray.join(',');
            this.ball.selected = [...inputArray];
        },

        removeDotDash() {
            this.ball.text = removeDotDash(this.ball.text);
        },

        // add to cart
        onAddToCart() {
            if (this.ball.max > this.ball.selected.length) {
                const param = {
                    text: this.getTranslatedText(`Please make sure that you select [number] of balls!`, {
                        number: this.ball.max,
                    }),
                    type: 'warning',
                };
                EventBus.emit('show-notications', param);

                return false;
            }

            const { game } = this.dataSource;
            console.log(game);
            const param = {
                id: new Date()
                    .getTime()
                    .toString(36)
                    .concat(performance.now().toString(), Math.random().toString())
                    .replace(/\./g, ''),
                slug: game.slug,
                selection: this.ball.selected.sort((a, b) => a - b),
                price: parseInt(this.wager.amount),
                draws: LOTTO_INSTANT.INSTANT_DRAWS,
                gameType: LOTTO_INSTANT.SLUG_GAME,
                eventDate: new Date(),
            };

            this.$store.dispatch('ModulesInstantLotto/actionAddToCart', param);

            this.onClearSelectNumber();
        },

        // format
        renderPrice(price, decimal = 0, isShowCurrency = true) {
            const priceReplace = parseFloat(price?.toString().replace(/,/g, ''));
            const priceFormat = isShowCurrency
                ? `${this.$store.state.config.setup.currency} ${formatPrice(priceReplace, decimal)}`
                : formatPrice(priceReplace, decimal);
            return priceFormat;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/number.scss';
</style>
